<template>
    <div class="designer-navigation-wrapper">
        <div class="designer-navigation-wrapper-inner">
            <div class="designer-navigation-items">
                <template v-for="component in visible_designer_configurator_components">
                    <div v-if='getLabel(component) != ""' class="designer-navigation-item">
                        <a href="#" @click.prevent.stop="jumpToComponent(component)">{{ getLabel(component) }}</a>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        props: {
            visible_designer_configurator_components: {
                required: true
            },
        },
        methods: {
            getLabel: function (component) {
                return window.trans("summary.label."+component);
            },
            jumpToComponent: function (component) {
                window.emitter.emit('jump-to-component', component);
            },
        },
    }
</script>
